import { BrochureItem } from "../../typing/main";

export const BROCHURES_CONFIG: BrochureItem[] = [
  {
    "text": "Download Warranty",
    "url": "/assets/cpo-results-app/static/CPO_Warranty_Manual_2025.pdf"
  },
  {
    "text": "Download CPO Brochure",
    "url": "/assets/cpo-results-app/static/2025_CPO Customer Brochure.pdf"
  }
]
